import { render, staticRenderFns } from "./ModalCreateOption.vue?vue&type=template&id=3ba6fc36"
import script from "./ModalCreateOption.vue?vue&type=script&lang=js"
export * from "./ModalCreateOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports